export const ENTITY = {
    TRANSPORT: "transport",
    AIR: "air",
    CARGO: "cargo",
    AUCTION: "auction",
};
